<template>
    <div class="slots-history" v-show="this.wins.length">
		<div class="slots-history__title">LIVE WINS</div>
        <div class="slots-history__items">
            <fade-transition group :duration="300">
                <div class="slots-history__item" v-for="win in this.wins" :key="win.id">
                    <router-link 
                        :key="win.game_id"
                        :to="{name: 'slotsGame', params: { gameId: win.game_id }}" 
                        class="slots-history__item-banner">
                        <img class="slots-history__item-img" :src="win.image" alt="">
                    </router-link>
                    <div class="slots-history__item-content">
                        <div class="slots-history__item-tags">
                            <span class="slots-history__item-tag slots-history__item-tag--success">{{ win.amount }}  ₽</span>
                            <span class="slots-history__item-tag slots-history__item-tag--danger" v-if="win.multiply > 3">
                                x{{ win.multiply }}
                            </span>
                            <span class="slots-history__item-tag" v-if="typeof win.multiply === 'string'">
                                {{ win.multiply }}
                            </span>
                        </div>
                        <router-link 
                            :key="win.game_id"
                            :title="win.game_name"
                            :to="{name: 'slotsGame', params: { gameId: win.game_id }}">
                            {{ win.game_name_short }}
                        </router-link>
                    </div>
                </div> 
            </fade-transition>
        </div>
    </div>
</template>

<script>
    import FadeTransition from "../Transitions/FadeTransition.vue";
    export default {
        components: {
            FadeTransition,
        },
        data() {
            return {
                tableLength: 5,
                firstRun: true,
                wins: []
            }
        },
        methods: {
            fillTable() {
                if(this.firstRun) {
                    this.$socket.emit('slotHistory', (data) => {
                        this.wins = data.wins.slice(0, this.tableLength);
                        this.firstRun = false;
                    });
                }
            },
        },
        sockets: {
            connect: function() {
                this.fillTable();
            },
            slotWin(win) {
                if (this.wins.length >= this.tableLength) {
                    this.wins.pop();
                }

                this.wins.unshift(win);
            }
        }
    }
</script>
